import { AxiosError, AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

// Response / Request
import { KeyValueEnum } from '@/main/models/common';
import { Result } from '@models/common/resultResponse';

// Redux
import { GetSchedulerUsers, saveSchedulerUsers } from './index';

// Api's
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';
import { userApi } from '../../api';

export function* getSchedulerUsersSaga(action: GetSchedulerUsers) {
  try {
    const response: AxiosResponse<Result<KeyValueEnum[]>> = yield call(
      userApi.getProcurementReportScheduleUsers,
      action.payload
    );

    if (response.data.result) {
      yield put(saveSchedulerUsers(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveSchedulerUsers(null, true, resultError.messagesDataError));
    }
  }
}
